import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const LanguageContext = createContext();

function langFromPath(pathname) {
  return (pathname === '/en' || pathname.startsWith('/en/')) ? 'en' : 'no';
}

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() =>
    langFromPath(window.location.pathname)
  );

  // Keep language in sync when URL changes (e.g. navigation)
  useEffect(() => {
    const onPopState = () => setLanguage(langFromPath(window.location.pathname));
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  const changeLanguage = useCallback((lang) => setLanguage(lang), []);

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
